import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceCreateForm } from '../components/onboarding/workspace-create-form.js';

export const Route = createFileRoute('/signup/workspace')({
  component: WorkspaceSignupRoute,
});

function WorkspaceSignupRoute() {
  return (
    <main className="flex min-h-svh items-center justify-center bg-muted p-6 md:p-10">
      <WorkspaceCreateForm />
    </main>
  );
}
